import { HttpResponse } from '@angular/common/http';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { AppConfig, appConfigService } from '@app/config';
import { DynamicFormService } from '@ntap/common';
import {
  DataSource,
  HttpMethod,
  HttpService,
  ItemProvider,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  ServerItemAction,
  ViewWindow
} from '@ntap/core';
import { map, Observable, pipe, take, tap } from 'rxjs';

@Component({
  selector: 'app-print-label-spremiste-pdf-action',
  templateUrl: './print-label-spremiste-pdf-action.component.html'
})
export class PrintLabelSpremistePdfActionComponent
  extends ServerItemAction
  implements OnInit
{
  protected pathReportPreviewPdf: string;

  constructor(
    protected override notificationService: NotificationService,
    @Optional() protected override itemProvider: ItemProvider,
    protected override dataSource: DataSource,
    @Optional() protected dynamicFormService: DynamicFormService,
    @Optional()
    protected override listViewProvider: ListViewProviderDirective<ListView>,
    @Optional() protected override window: ViewWindow,
    @Inject(appConfigService) private config: AppConfig,
    private httpService: HttpService
  ) {
    super(notificationService, itemProvider, dataSource, listViewProvider);
    this.config = config;
    this.httpService = httpService;
  }

  enabled$: Observable<boolean>;

  private baseUrl = this.config.apiHost;

  ngOnInit(): void {
    if (this.listViewProvider) {
      this.enabled$ = this.listViewProvider?.selectedItems$.pipe(
        map((selected) => selected.length > 0)
      );
    }
  }

  printLabelSpremistePdf(): void {
    this.listViewProvider?.selectedItems$
      .pipe(take(1))
      .subscribe((selectedItems: any[]) => {
        if (selectedItems) {
          const sId = selectedItems.map((e) =>
            e['earhiv~spremiste_lokacija~id']
              ? e['earhiv~spremiste_lokacija~id']
              : e['earhiv~spremiste_spremisna_jedinica~id']
              ? e['earhiv~spremiste_spremisna_jedinica~id']
              : e['earhiv~spremiste_prostorija~id']
              ? e['earhiv~spremiste_prostorija~id']
              : e['earhiv~spremiste_objekt~id']
          );
          const payload = {
            format: 'pdf',
            reportParams: {
              spremiste_id: sId,
              slobodan_unos: this.dynamicFormService.getFormValue(
                'earhiv~ispis_naljepnica~slobodni_unos'
              ),
              formati_ispis: this.dynamicFormService.getFormValue(
                'earhiv~ispis_naljepnica~formati_ispisa'
              )
            }
          };
          this.previewReport(payload).subscribe();
        }
      });
  }

  protected doDownload = pipe(
    map((response: HttpResponse<any>) => {
      return this.extractResponseBlob(response);
    }),
    tap((data) => {
      this.downloadLink(data);
    })
  );

  public previewReport(body: any) {
    const url = `${this.baseUrl}print-label/spremiste_objekti`;
    return this.httpService
      .request(HttpMethod.POST, url, body, {
        responseType: 'blob',
        observe: 'response'
      })
      .pipe(
        map((response) => {
          return this.extractResponseBlob(response);
        }),
        tap((data) => {
          this.downloadLink(data);
        })
      );
  }

  private downloadLink(data: any) {
    const element = document.createElement('a');
    element.href = URL.createObjectURL(data.file);
    element.download = data.filename;
    document.body.appendChild(element);
    element.click();
    element.remove();
  }

  private extractResponseBlob(response: any): { file: Blob; filename: string } {
    const contentDisposition = response.headers.get('Content-Disposition');
    const filename = contentDisposition!.substring(
      contentDisposition!.indexOf('=') + 1
    );
    const mimeType = response.headers.get('Content-Type') || '';
    const data = {
      file: new Blob([response.body], { type: mimeType }),
      filename: filename
    };
    return data;
  }
}
